import { generateClient } from 'aws-amplify/api';
import { listMessages } from '../graphql/queries';
import { deleteMessage } from '../graphql/mutations';

const client = generateClient();

export const fetchMessages = async () => {
  try {
    const result = await client.graphql({ query: listMessages });
    const messages = result.data.listMessages.items;
    return messages;
  } catch (error) {
    console.error('Failed to fetch messages:', error);
    throw error;
  }
};

export const deleteMessages = async (id: string) => {
  const client = generateClient();
  try {
    const response = await client.graphql({
      query: deleteMessage,
      variables: { input: { id } }
    });

    if (response.data && response.data.deleteMessage) {
      console.log('Delete response:', response.data.deleteMessage);
      alert('Delete successful');
    } else {
      console.error('Failed to delete message: No deleteMessage data');
      alert('Failed to delete');
    }
  } catch (error) {
    console.error('Delete failed:', error);
    alert('Error during deletion');
  }
};

